<div class="login-wrapper">
  <div class="overlay"></div>

  <div class="modal-card">
    <div class="logo-container">
      <img src="/images/logo.png" alt="Associate Logo" class="brand-logo" />
    </div>

    <ng-container *ngIf="currentStep === 'phone'">
      <div class="text-block">
        <h2 class="title">Associate Login</h2>
        <p class="subtitle">
          Login to access your skincare routine, orders, wishlist, and exclusive offers.
        </p>
      </div>

      <form [formGroup]="phoneForm" class="form-block">
        <div class="input-wrapper">
          <i class="fa-solid fa-phone input-icon"></i>
          <input
            type="tel"
            placeholder="Phone Number"
            formControlName="phoneNumber"
            class="custom-input"
            maxlength="10"
          />
        </div>

        <button type="button" class="btn-black mt-4" (click)="requestOtp()">Send OTP</button>
      </form>
    </ng-container>

    <ng-container *ngIf="currentStep === 'otp'">
      <div class="text-block">
        <h2 class="title">Verify</h2>
        <p class="subtitle">Almost there! Enter the OTP to continue</p>
      </div>

      <div class="form-block">
        <div class="otp-container">
          <input
            *ngFor="let i of [0, 1, 2, 3]"
            type="text"
            [id]="'otp-' + i"
            [(ngModel)]="otpArray[i]"
            (keyup)="onOtpKeyUp($event, i)"
            (keydown)="onOtpKeyDown($event, i)"
            maxlength="1"
            inputmode="numeric"
            class="otp-box"
          />
        </div>

        <div class="timer-text mt-3">
          <span *ngIf="timeLeft > 0"
            >Didn't receive it? Resend code in <strong>{{ timerDisplay }}</strong></span
          >
          <span *ngIf="timeLeft === 0" class="resend-link" (click)="resendOtp()"
            >Resend OTP Now</span
          >
        </div>

        <button type="button" class="btn-black mt-4" (click)="verifyAndLogin()">Verify</button>
      </div>
    </ng-container>
  </div>
</div>
